import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";
import { FiLoader } from "react-icons/fi";

export default function ImageUploader({ value, onChange, placeholder = "Նկարի URL" }) {
  const [uploading, setUploading] = useState(false);

  const convertToWebP = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const canvas = document.createElement("canvas");
        
        // Նոր չափսերը
        const TARGET_WIDTH = 600;
        const TARGET_HEIGHT = 750;
        canvas.width = TARGET_WIDTH;
        canvas.height = TARGET_HEIGHT;
        
        const ctx = canvas.getContext("2d");
        
        // Հաշվում ենք ճիշտ չափերը՝ նկարը չաղավաղելու համար (object-fit: cover տրամաբանությամբ)
        const targetRatio = TARGET_WIDTH / TARGET_HEIGHT;
        const imgRatio = img.width / img.height;
        let drawWidth = TARGET_WIDTH;
        let drawHeight = TARGET_HEIGHT;
        let offsetX = 0;
        let offsetY = 0;

        if (imgRatio > targetRatio) {
          drawWidth = TARGET_HEIGHT * imgRatio;
          offsetX = (TARGET_WIDTH - drawWidth) / 2;
        } else {
          drawHeight = TARGET_WIDTH / imgRatio;
          offsetY = (TARGET_HEIGHT - drawHeight) / 2;
        }

        ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
        // Կոնվերտացիա դեպի WebP, 0.8 (80%) որակով
        canvas.toBlob((blob) => {
          if (blob) resolve(blob);
          else reject(new Error("WebP conversion failed"));
        }, "image/webp", 0.8); 
      };
      img.onerror = (error) => reject(error);
    });
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      let uploadFile = file;
      let fileName = file.name;

      // Ստուգում ենք արդյոք ֆայլը նկար է և արդեն WebP չէ
      if (file.type.startsWith("image/") && file.type !== "image/webp") {
        try {
          uploadFile = await convertToWebP(file);
          // Փոխում ենք ընդլայնումը .webp-ի
          fileName = fileName.replace(/\.[^/.]+$/, "") + ".webp";
        } catch (err) {
          console.error("Չհաջողվեց կոնվերտացնել WebP-ի, բեռնվում է օրիգինալ ֆայլը:", err);
        }
      }

      const fileRef = ref(storage, `uploads/${Date.now()}_${fileName}`);
      await uploadBytes(fileRef, uploadFile);
      const url = await getDownloadURL(fileRef);
      onChange(url);
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Նկարի բեռնումը ձախողվեց: Համոզվեք, որ Firebase Storage-ը միացված է և storage փոփոխականը արտահանված է firebase.js-ից:");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ border: "1px dashed #aaa", padding: "10px", borderRadius: "6px", marginBottom: "10px", backgroundColor: "#fdfdfd" }}>
      <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
        <input type="file" accept="image/*" onChange={handleUpload} disabled={uploading} />
        {uploading && <span style={{ color: "blue", fontSize: "14px", display: "flex", alignItems: "center", gap: "4px" }}><FiLoader /> Բեռնվում է...</span>}
      </div>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
      />
      {value && (
        <div style={{ marginTop: "10px" }}>
          <img src={value} alt="preview" style={{ width: "100%", height: "250px", objectFit: "cover", borderRadius: "8px", border: "1px solid #f3f4f6" }} />
        </div>
      )}
    </div>
  );
}